import React from "react";
import t from "../../../../i18n";
import LabelledHint from "./StatusDisplay/LabelledHint";
import type { Setup } from "../../../../api/useSetups";
import { SimulationStatus, GlobalDiagnosisStatus } from "../../../../api/useSetups";
import { StatusDisplay, mapStatusDisplay } from "./StatusDisplay/utils";
import Tab from "@ui/NavV2/Tab";
import NavV2 from "@ui/NavV2";
import { toPath, useIsCurrentRouteMatching } from "../../../../router/helpers/path";

interface P {
  projectId: string;
  setup: Setup;
}

const simulationHintStatus = mapStatusDisplay<SimulationStatus>([
  [SimulationStatus.VALIDATING, StatusDisplay.WARNING],
  [SimulationStatus.VALID, StatusDisplay.SUCCESS],
  [SimulationStatus.INCOMPLETE, StatusDisplay.PENDING],
  [SimulationStatus.INVALID, StatusDisplay.ERROR],
]);

const diagnosisHintStatus = mapStatusDisplay<GlobalDiagnosisStatus>([
  [GlobalDiagnosisStatus.COMPLETE, StatusDisplay.SUCCESS],
  [GlobalDiagnosisStatus.INCOMPLETE, StatusDisplay.PENDING],
  [GlobalDiagnosisStatus.INVALID, StatusDisplay.ERROR],
]);

export const SetupNavBar = React.memo(({ projectId, setup }: P) => {
  const isSetupSimulationRoute = useIsCurrentRouteMatching(
    "/projects/:projectId/setup/:setupId/simulation",
  );
  const isSetupDiagnosisRoute = useIsCurrentRouteMatching(
    "/projects/:projectId/setup/:setupId/diagnosis",
  );

  return (
    <NavV2>
      <Tab
        active={isSetupSimulationRoute}
        to={toPath("/projects/:projectId/setup/:setupId/simulation", {
          setupId: setup.id,
          projectId,
        })}
      >
        <LabelledHint
          status={simulationHintStatus(setup.simulationStatus)}
          label={t("setup.header.nav.simulation")}
        />
      </Tab>
      <Tab
        active={isSetupDiagnosisRoute}
        to={toPath("/projects/:projectId/setup/:setupId/diagnosis", {
          setupId: setup.id,
          projectId,
        })}
      >
        <LabelledHint
          status={diagnosisHintStatus(setup.diagnosisStatus)}
          label={t("setup.header.nav.diagnosis")}
        />
      </Tab>
    </NavV2>
  );
});
